// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080234/js/" + chunkId + "." + {"44":"f1ab3e48","225":"252c7706","481":"286ed014","486":"64add5fe","770":"9146bf74"}[chunkId] + ".0.6219947391563786.chunk.js";
};